import { render } from "./Popup.vue?vue&type=template&id=68a4d4e1"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=68a4d4e1&lang=css"
script.render = render

export default script